import { Component, OnInit, Input } from '@angular/core';
import { SubscriberService } from '@services';
import { PopoverService } from '@services/popover/popover.service';
import { PopupObservationService, isMaintainXWorkOrder } from '@services/observationDetail/popup-observation.service';
import { Feature } from '@services/subscriber/subscriber.service';

@Component({
  selector: 'app-cancelworkorder-popup',
  templateUrl: './cancelworkorder-popup.component.html',
  styleUrls: ['./cancelworkorder-popup.component.scss'],
})

export class CancelworkorderPopupComponent implements OnInit {
  @Input() observationID: Number;
  @Input() workorder: string;
  @Input() workorderStatus: string;
  public usesMaintainX = false;

  constructor(private popoverService: PopoverService,
              private subscriber: SubscriberService,
              private popOps: PopupObservationService) {
  }

  ngOnInit() {
    // a hand-entered (non-numeric) work order is cancelled locally, not in MaintainX
    if (this.subscriber.usesFeature(Feature.OBSERVATION_MAINTAINX) && isMaintainXWorkOrder(this.workorder, this.workorderStatus)) {
      this.usesMaintainX = true;
    }
  }

  public async close(): Promise<void> {
    await this.popoverService.safeDismiss();
  }

  public async cancelWO(): Promise<void> {
    this.popOps.cancelWorkOrder(this.observationID);
    await this.popoverService.safeDismiss();
  }
}
